import { Controller } from '@hotwired/stimulus'
import parsePhoneNumber from 'libphonenumber-js/max'

export default class extends Controller {
  static targets = [
    'form',
    'moveout',
    'symptomOfDementias',
    'prefectures',
    'cities',
    'towns',
    'telInput',
    'telError',
    'submit',
  ]

  updateTowns (towns) {
    this.townsTarget.innerHTML = '<option value="">町名を選択してください</option>'
    towns.forEach(town => {
      const option = document.createElement('option')
      option.value = town.id
      option.textContent = town.name
      this.townsTarget.appendChild(option)
    })
  }

  updateCities (cities) {
    this.citiesTarget.innerHTML = '<option value="">市区町村を選択してください</option>'
    cities.forEach(city => {
      const option = document.createElement('option')
      option.value = city.id
      option.textContent = city.name
      this.citiesTarget.appendChild(option)
    })
  }

  changePrefecture () {
    if (this.prefectureId) {
      fetch(`/area/prefectures/${this.prefectureId}/cities.json`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then(cities => this.updateCities(cities))
        .catch(error => {
          console.error('Failed to fetch cities:', error)
          this.updateCities([])
        })
    }
    this.citiesTarget.value = ''
    this.townsTarget.value = ''
  }

  changeCity () {
    if (this.cityId) {
      fetch(`/area/cities/${this.cityId}/towns`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.json()
        })
        .then(towns => this.updateTowns(towns))
        .catch(error => {
          console.error('Failed to fetch towns:', error)
          this.updateTowns([])
        })
    }
    this.townsTarget.value = ''
  }

  changeCurrentStatus (e) {
    // Ca::Request::CurrentResidenceのID: 1=病院, 2=老人保健施設, 3=特別養護老人ホーム
    // 上記3つの状態の場合のみ退院・退去予定時期の入力フィールドを表示
    if ((e.target.value === '1' || e.target.value === '2' || e.target.value === '3')) {
      this.moveoutTarget.style.display = 'block'
      this.moveoutTarget.querySelector('select').disabled = false
    } else {
      this.moveoutTarget.style.display = 'none'
      this.moveoutTarget.querySelector('select').disabled = true
    }
  }

  changeDementia (e) {
    // Nursing::DementiaDiagnosisのID: 1=認知症あり
    // 認知症ありの場合のみ症状の詳細入力フィールドを表示
    if (e.target.value === '1') {
      this.symptomOfDementiasTarget.style.display = 'block'
      this.symptomOfDementiasTarget.querySelectorAll('input').forEach(element => (element.disabled = false))
    } else {
      this.symptomOfDementiasTarget.style.display = 'none'
      this.symptomOfDementiasTarget.querySelectorAll('input').forEach(element => (element.disabled = true))
    }
  }

  validateTel () {
    const value = this.telInputTarget.value
    if (value) {
      const phoneNumber = parsePhoneNumber(value, 'JP')
      if (phoneNumber?.isValid()) {
        this.submitTarget.disabled = false
        this.telErrorTarget.style.display = 'none'
      } else {
        this.submitTarget.disabled = true
        this.telErrorTarget.style.display = 'flex'
      }
    }
  }

  get prefectureId () {
    return this.prefecturesTarget.value
  }

  get cityId () {
    return this.citiesTarget.value
  }
}
